export default (function (theme) {
  return {
    formControlLabel: {
      paddingTop: '1.4em',
      '& span': {
        fontSize: '1em'
      }
    }
  };
});